<template>
  <v-dialog max-width="600" max-height="600" v-model="show" persistent>
    <v-card class="pa-2" data-testid="create-batch-dialog">
      <v-card-title>
        <div class="d-flex align-center justify-center">
          <div class="md-subheader-no-spacing">
            <div v-if="completeStore">
              Process Pending Orders and Complete Store
            </div>
            <div v-else>
              Create Batch
            </div>
          </div>
          <v-spacer />
          <v-btn
            style="left: 15px"
            icon
            variant="plain"
            data-testid="create-batch-dialog-close"
            @click="cancel"
            ><v-icon icon="close" /></v-btn
          >
        </div>
        <div class="md-body-no-spacing">
          <div>
            To create a batch, input a name for your batch and your applicable
            purchase order number. Then select process orders.
          </div>
          <div class="mt-2">
            This will create relevant reports for the orders in this batch.
          </div>
          <div v-if="completeStore">
            Your store will be completed after the batch is created
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="form" @submit.prevent="submit">
          <v-text-field
            label="Enter Batch Name"
            v-model="batchName"
            :rules="[validateNotEmpty, validateNotSpaces]"
          />
          <v-text-field
            label="Distributor PO #"
            v-model="distributorPO"
            :rules="[validateNotEmpty, validateNotSpaces]"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="completeStore"
          color="primary"
          variant="text"
          @click="createBatchAndCompleteStore"
          :disabled="!valid"
        >
          Process Orders and Complete Store
        </v-btn>
        <v-btn
          v-else
          color="primary"
          variant="text"
          @click="createBatch"
          :disabled="!valid"
        >
          Batch and Process Orders
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/mixins/rules";
import helpers from "@/mixins/helpers";

export default {
  props: {
    completeStore: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [rules, helpers],

  watch: {},

  data() {
    return {
      show: false,
      batchName: "",
      distributorPO: null,
      valid: false,
    };
  },

  async mounted() {},

  methods: {
    open() {
      this.batchName = "";
      this.distributorPO = null;
      this.show = true;
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.reset();
      });
    },

    createBatch() {
      this.batchName.trim();
      if (this.completeStore) {
        this.distributorPO.trim();
      }
      this.$emit("createBatch");
      this.show = false;
    },

    createBatchAndCompleteStore() {
      this.$emit("createBatchAndCompleteStore", this.distributorPO);
      this.show = false;
    },

    submit() {
      if (this.completeStore) {
        this.createBatchAndCompleteStore();
      } else {
        this.createBatch();
      }
    },

    cancel() {
      this.show = false;
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped></style>
